import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Card, Col, Container, Row, Form, Button, Modal} from "react-bootstrap";
import {Link} from "react-router-dom";
import TableContainer from "Common/TableContainer";
import 'react-toastify/dist/ReactToastify.css';
import {DeleteModal} from "Common/DeleteModal";
import {
    getBannerSlider as onGetBannerSlider,
    addBannerSlider as onAddBannerSlider,
    updateBannerSlider as onUpdateBannerSlider,
    deleteBannerSlider as onDeleteBannerSlider
} from "slices/pages/bannerSlider/thunk";
import {useDispatch, useSelector} from "react-redux";
import {ToastContainer} from "react-toastify";
import {createSelector} from "reselect";
import {useFormik} from "formik";
import * as Yup from "yup";
import Dropzone from "react-dropzone";

const url = process.env.REACT_APP_API_URL;

const RightBanner = () => {

    document.title = "Banner Slider";
    const dispatch = useDispatch<any>();

    const selectBannerSlider = createSelector(
        (state: any) => state.BannerSlider,
        (bannerSlider) => ({
            bannerSliderList: bannerSlider.bannerSliderList
        })
    );

    const {bannerSliderList} = useSelector(selectBannerSlider);
    console.log(bannerSliderList)
    useEffect(() => {
        dispatch(onGetBannerSlider());
    }, [dispatch]);

    const [listView, setListView] = useState<any>();
    const [bannerSliderLists, setBannerSliders] = useState<any>(null);
    const [addBannerSlider, setAddBannerSlider] = useState<boolean>(false);
    const [editBannerSlider, setEditBannerSlider] = useState<boolean>(false);
    const [show, setShow] = useState<boolean>(false);
    const [edit, setEdit] = useState<any>();
    const [selectFile, setSelectFile] = useState<any>([]);
    const [selectFileMobile, setSelectFileMobile] = useState<any>([]);
    //add
    const handleCloseBannerSlider = () => {
        setAddBannerSlider(false);
        setSelectFile(null);
    }
    const handleShowBannerSlider = () => setAddBannerSlider(true);
    //edit
    const handleEdit = useCallback((item: any) => {
        const lastItem = item.row.original
        setAddBannerSlider(true);
        setEditBannerSlider(true);
        setEdit({
            id: lastItem.id,
            bannerSlider: lastItem.name,
            img: lastItem.imageUrl,
        });
        console.log(lastItem)
        // setSelectFile(lastItem?.imgUrl);

    }, []);

    //search
    const handleChange = (ele: any) => {
        let search = ele.target.value;
        if (search) {
            setListView(bannerSliderList.content?.filter((item: any) => item.name.toLowerCase().includes(search)));
        } else {
            setListView(bannerSliderList.content);
        }
    };

    // delete
    const handleDeleteShow = (ele: any) => {
        setShow(true);
        setBannerSliders(ele);
    };

    const handleDeleteClose = () => {
        setShow(false);
    }

    //delete modal
    const deleteModalFunction = () => {
        const deleteData = bannerSliderLists.row.original.id || {};
        console.log(deleteData);
        if (deleteData) {
            dispatch(onDeleteBannerSlider(deleteData));
        }
        setShow(false);
    };

    useEffect(() => {
        setListView(bannerSliderList?.content);
    }, [bannerSliderList]);

    //columns
    const columns = useMemo(
        () => [
            {
                header: (
                    <Form.Check>
                        <Form.Check.Input type="checkbox" value="option" id="checkAll"/>
                        <Form.Check.Label htmlFor="checkAll"></Form.Check.Label>
                    </Form.Check>
                ),
                cell: (cell: any) => {
                    return (
                        <Form.Check className="checkbox-product-list">
                            <Form.Check.Input type="checkbox" value="2" id="checkbox-2"/>
                            <Form.Check.Label htmlFor="checkbox-2"></Form.Check.Label>
                        </Form.Check>
                    );
                },
                id: "#",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "№",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => {
                    return (
                        <span>{cell.row.index + 1}</span>
                    )
                }
            },
            {
                header: "Images",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => {
                    return (
                        <div className={""}>
                            <img src={url + cell.row.original.imageUrl} alt={""}
                                 className={"category_img"}/>
                        </div>
                    )
                }
            },
            {
                header: "BannerSlider name",
                accessorKey: "name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Created At",
                accessorKey: "createdAt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Updated At",
                accessorKey: "updatedAt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Action",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => {
                    return (
                        <ul className="d-flex gap-2 list-unstyled mb-0">
                            <li>
                                <Link to="#" className="btn btn-subtle-secondary btn-icon btn-sm edit-item-btn"
                                      onClick={() => handleEdit(cell)}><i className="ph-pencil"></i></Link>
                            </li>
                            <li className={"mx-2"}>
                                <Link to="#" className="btn btn-subtle-danger btn-icon btn-sm remove-item-btn"
                                      onClick={() => handleDeleteShow(cell)}><i className="ph-trash"></i></Link>
                            </li>
                        </ul>
                    );
                }
            },
        ], []
    );

    // validation
    const formik: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            title: (edit && edit.title) || '',
            id: edit && edit.id,
            mobileImage: edit && edit.mobileImage,
            desktopImage: edit && edit.desktopImage,
            path: edit && edit.path,
            order: edit && edit.order,
        },
        validationSchema: Yup.object({
            title: Yup.string().required("Please Enter Your BannerSlider"),
            mobileImage: Yup.mixed().required("Please Enter Your BannerSlider mobile Image"),
            desktopImage: Yup.mixed().required("Please Enter Your BannerSlider Image"),
            path: Yup.string().required("Please Enter Your link"),
            order: Yup.string().required("Please Enter Banner order"),
        }),

        onSubmit: (values: any) => {

            if (editBannerSlider) {
                const data: any = {
                    name: values.bannerSlider,
                    id: values.id
                }
                const updateFormData = new FormData();
                updateFormData.append('bannerSliderDto', new Blob([JSON.stringify(data)], {type: 'application/json'}));
                updateFormData.append('image', values.img);

                dispatch(onUpdateBannerSlider({updateFormData: updateFormData, id: values.id}));
                formik.resetForm();
            } else {
                const data: any = {
                    name: values.bannerSlider
                }
                const formData = new FormData();
                formData.append('bannerSliderDto', new Blob([JSON.stringify(data)], {type: 'application/json'}));
                formData.append('image', values.img);

                console.log(values.img)
                dispatch(onAddBannerSlider(formData));
                formik.resetForm();
            }

            setEdit(null);
            setEditBannerSlider(false);
            handleCloseBannerSlider();
            setSelectFile([]);
        }
    });

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Row id="bannerSliderList">
                        <Col lg={12}>
                            <Card>
                                <Card.Header>
                                    <Row className="align-items-center g-2">
                                        <Col lg={3} className="me-auto">
                                            <h6 className="card-title mb-0">Right Banner</h6>
                                        </Col>
                                        <Col xl={2} md={3}>
                                            <div className="search-box">
                                                <Form.Control
                                                    type="text" className="search"
                                                    placeholder="Search RightBanner..."
                                                    onChange={(e: any) => handleChange(e)}
                                                />
                                                <i className="ri-search-line search-icon"></i>
                                            </div>
                                        </Col>
                                        <Col className="col-md-auto">
                                            <div className="hstack gap-2">
                                                <Button className="btn btn-subtle-danger d-none" id="remove-actions">
                                                    <i className="ri-delete-bin-2-line"></i>
                                                </Button>
                                                <Button variant="secondary" onClick={handleShowBannerSlider}>
                                                    <i className="bi bi-plus-circle align-baseline me-1"></i> Add
                                                    RightBanner
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Header>
                                <Card.Body className="mt-3">
                                    {
                                        listView && listView.length > 0 ?
                                            <TableContainer
                                                isPagination={true}
                                                columns={columns}
                                                data={listView || []}
                                                customPageSize={10}
                                                divClassName="table-responsive table-card"
                                                tableClass="table table-centered align-middle table-custom-effect table-nowrap mb-0"
                                                theadClass="table-light"
                                                PaginationClassName="align-items-center mt-4 pt-3"
                                                isBordered={false}
                                            />
                                            :
                                            <div id="noresult">
                                                <div className="text-center py-4">
                                                    <div className="avatar-md mx-auto mb-4">
                                                        <div
                                                            className="avatar-title bg-primary-subtle text-primary rounded-circle fs-5xl">
                                                            <i className="bi bi-search"></i>
                                                        </div>
                                                    </div>
                                                    <h5 className="mt-2">Sorry! No Result Found</h5>
                                                </div>
                                            </div>
                                    }
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>
                </Container>
            </div>
            <DeleteModal show={show} handleClose={handleDeleteClose} deleteModalFunction={deleteModalFunction}/>

            <Modal show={addBannerSlider} onHide={handleCloseBannerSlider}>
                <Modal.Header closeButton>
                    <Modal.Title>{editBannerSlider ? "update RightBanner" : "Add RightBanner"}</Modal.Title>
                </Modal.Header>
                <Form autoComplete="off" onSubmit={formik.handleSubmit}>
                    <Modal.Body>
                        <div className="mb-3">
                            <Form.Label htmlFor="bannerSliderTitle">Right Banner Name<span
                                className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="text"
                                id="bannerSliderTitle"
                                name="title"
                                placeholder="Name"
                                value={formik.values.title}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={!!formik.errors.title}
                            />
                            {formik.errors.title && formik.touched.title ? (
                                <Form.Control.Feedback
                                    type="invalid">{formik.errors.title}</Form.Control.Feedback>
                            ) : null}
                        </div>
                        <Row className="mb-3">
                            <Col lg={6}>
                                <div className="mb-3">
                                    <Form.Label htmlFor="bannerSliderLink">Link<span
                                        className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="bannerSliderLink"
                                        name="path"
                                        placeholder="Link"
                                        value={formik.values.path}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isInvalid={!!formik.errors.path}
                                    />
                                    {formik.errors.path && formik.touched.path ? (
                                        <Form.Control.Feedback
                                            type="invalid">{formik.errors.path}</Form.Control.Feedback>
                                    ) : null}
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="mb-3">
                                    <Form.Label htmlFor="bannerSliderOrder">Order<span
                                        className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        type="number"
                                        id="bannerSliderOrder"
                                        name="order"
                                        placeholder="Order"
                                        value={formik.values.order}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isInvalid={!!formik.errors.order}
                                    />
                                    {formik.errors.order && formik.touched.order ? (
                                        <Form.Control.Feedback
                                            type="invalid">{formik.errors.order}</Form.Control.Feedback>
                                    ) : null}
                                </div>

                            </Col>
                        </Row>

                        <div className="mb-3">
                            <Dropzone
                                onDrop={(acceptedFiles: File[]) => {
                                    if (acceptedFiles.length > 0) {
                                        formik.setFieldValue("img", acceptedFiles[0]);
                                        setSelectFile(acceptedFiles)
                                    }
                                }}
                                multiple={false}
                                accept={{"image/*": []}}
                            >
                                {(dropzoneProps: any) => {
                                    const {getRootProps, getInputProps} = dropzoneProps;
                                    return (
                                        <div className="mb-3">
                                            <Form.Label htmlFor="product-images-input">Right Banner Image</Form.Label>
                                            <div
                                                {...getRootProps()}
                                                className="dropzone my-dropzone border border-1 border-dashed text-center dz-clickable"
                                                style={{minHeight: "100px"}}
                                            >
                                                <input {...getInputProps()} name="desktopImage"
                                                       onBlur={formik.handleBlur}/>
                                                <div className="dz-message needsclick py-3">
                                                    <i className="bi bi-cloud-download fs-1 mb-2"/>
                                                    <h5>Drop files here or click to upload.</h5>
                                                </div>
                                            </div>
                                            {formik.errors.desktopImage && formik.touched.desktopImage && (
                                                <Form.Control.Feedback type="invalid" className="d-block">
                                                    {formik.errors.desktopImage}
                                                </Form.Control.Feedback>
                                            )}
                                        </div>
                                    );
                                }}
                            </Dropzone>

                            <ul className="list-unstyled mb-3" id="dropzone-preview">
                                {selectFile?.map((file: any, index: any) => (
                                    <li className="mt-2 dz-image-preview" key={index}>
                                        <div className="border rounded">
                                            <div className="d-flex flex-wrap gap-2 p-2">
                                                <div className="flex-shrink-0 me-3">
                                                    <div className="avatar-sm bg-light rounded p-2">
                                                        <img data-dz-thumbnail=""
                                                             className="img-fluid rounded d-block"
                                                             src={URL.createObjectURL(file)}
                                                             alt={file?.name}/>
                                                    </div>
                                                </div>
                                                <div className="flex-grow-1">
                                                    <div className="pt-1">
                                                        <h5 className="fs-md mb-1">{file.name}</h5>
                                                        <p className="fs-sm text-muted mb-0">
                                                            {(file.size / 1024).toFixed(2)} KB
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="flex-shrink-0 ms-3">
                                                    <Button
                                                        variant="danger"
                                                        size="sm"
                                                        onClick={() => {
                                                            setSelectFile([]);
                                                            formik.setFieldValue("img", null);
                                                        }}
                                                    >
                                                        Delete
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" className="btn btn-ghost-danger" onClick={handleCloseBannerSlider}>
                            <i className="bi bi-x-lg align-baseline me-1"></i> Close
                        </Button>
                        <Button
                            type="submit"
                            variant="primary"
                            id="add-btn"
                        >
                            {editBannerSlider ? "update" : "Add RightBanner"}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
            <ToastContainer/>
        </React.Fragment>
    );
};

export default RightBanner;